import styled from 'styled-components';

export const Container = styled.div`
  background: #312e38;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 20px;

  button {
    width: 40%;
  }
`;
